import { slotMetadataStore } from '@client/core/utils/pulse/gamDataStore.js';

import { onImpressionViewable } from './onImpressionViewable.js';
import { onSlotOnload } from './onSlotOnload.js';
import { onSlotRenderEnded } from './onSlotRenderEnded.js';
import { onSlotRequested } from './onSlotRequested.js';
import { onSlotVisibilityChanged } from './onSlotVisibilityChanged.js';
import { Api } from '../Api/index.js';

export async function setup(...abortSignals: ReadonlyArray<AbortSignal>) {
  const googletag = await Api(...abortSignals);

  googletag.pubads().addEventListener('slotRequested', onSlotRequested);
  googletag.pubads().addEventListener('slotRenderEnded', (event) => {
    slotMetadataStore.setFromEvent(event);

    onSlotRenderEnded(event);
  });

  googletag
    .pubads()
    .addEventListener('impressionViewable', onImpressionViewable);

  googletag
    .pubads()
    .addEventListener('slotVisibilityChanged', onSlotVisibilityChanged);

  googletag.pubads().addEventListener('slotOnload', onSlotOnload);
}
